// styles/bottomSheetStyles.ts
import { css } from 'styled-components';

export const keywordBaseStyle = css`
  background-color: #f3f4f6;
  color: #1447e6;
  padding: 2px 4px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
`;
